import React, { useState } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import * as Yup from 'yup';
import { Formik } from 'formik';
import { useSnackbar } from 'notistack';
import {
  Box,
  Button,
  Card,
  CardContent,
  Grid,
} from '@material-ui/core';
import { Redirect } from 'react-router';
import CustomTextField from '../../../components/Inputs/TextField/CustomTextField';
import CustomAutocomplete from '../../../components/Inputs/Autocomplete/CustomAutocomplete';
import { SUPER_ADMIN } from '../../../utils/const/user_types';
import useStyles from './styles';
import { postNewPriceList } from '../../../requests/api/priceLists';
import handleApiResponse from '../../../utils/handleApiResponse';

function PriceListCreateForm({
  className,
  role,
  clients,
  selectedClient,
  setSelectedClient,
  ...rest
}) {
  const classes = useStyles();

  const { enqueueSnackbar } = useSnackbar();
  const [submitSuccess, setSubmitSuccess] = useState(false);

  if (submitSuccess) {
    return <Redirect to="/precios" />;
  }

  return (
    <Formik
      initialValues={{
        name: '',
      }}
      validationSchema={Yup.object().shape({
        name: Yup.string().max(255).required('Debe ingresar un nombre'),
      })}
      onSubmit={async (values, {
        setErrors,
        setStatus,
        setSubmitting,
      }) => {
        try {
          // Make API request
          const data = {
            name: values.name,
          };

          const response = await postNewPriceList(data, selectedClient.id);

          handleApiResponse(enqueueSnackbar, response, true);
          setStatus({ success: true });
          setSubmitting(false);
          setSubmitSuccess(true);
        } catch (error) {
          handleApiResponse(enqueueSnackbar, error, false, 'error', <Button href="/precios">Volver a Lista de Precios</Button>);
          setStatus({ success: false });
          setErrors({ submit: error.message });
          setSubmitting(false);
        }
      }}
    >
      {({
        errors,
        handleBlur,
        handleChange,
        handleSubmit,
        isSubmitting,
        touched,
        values,
      }) => (
        <form
          className={clsx(classes.rootCreateForm, className)}
          onSubmit={handleSubmit}
          {...rest}
        >

          <Card>
            <CardContent>
              <Grid
                container
                spacing={3}
              >
                <Grid
                  item
                  md={6}
                  xs={12}
                >
                  <CustomTextField
                    error={Boolean(touched.name && errors.name)}
                    fullWidth
                    helperText={touched.name && errors.name}
                    label="Nombre"
                    name="name"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    required
                    value={values.name}
                    variant="outlined"
                  />
                </Grid>
                {role === SUPER_ADMIN && <Grid item md={6} xs={12}>
                <CustomAutocomplete
                    isOptionEqualToValue={(option, value) => option.id === value.id}
                    disablePortal
                    id="combo-box-demo"
                    fullWidth
                    options={clients}
                    getOptionLabel={(option) => `${option.name}`}
                    onChange={(e, value) => {
                      if (value === null) {
                        setSelectedClient({
                          id: clients[0].id,
                          name: clients[0].name,
                        });
                        return;
                      }
                      setSelectedClient({
                        id: value.id,
                        name: value.name,
                      });
                    }}
                    renderInput={(params) => (
                        <CustomTextField
                        {...params}
                        label="Buscar cliente"
                        variant="outlined"
                    />
                    )}
                    />
                </Grid>
                    }
              </Grid>
              <Box
                mt={2}
                display='flex'
                justifyContent='flex-end'
                >
                <Button
                  variant="contained"
                  color="primary"
                  type="submit"
                  disabled={isSubmitting}
                >
                  Guardar
                </Button>
              </Box>
            </CardContent>
          </Card>
        </form>
      )}
    </Formik>
  );
}

PriceListCreateForm.propTypes = {
  className: PropTypes.string,
};

export default PriceListCreateForm;
